import {history} from '../../../history'

export default function onRow(record) {
  return {
    style: {cursor: `pointer`},
    onClick: (e) => {
      if (e.metaKey) return window.open(`/projects/${record.id}/manage`)
      history.push(`/projects/${record.id}/manage`)
    },
  }
}
